import { CampaignState } from './types'

export const getDetailsData = (state: CampaignState) => state.detailsData.data
export const getDetailsStatus = (state: CampaignState) => state.detailsData.status
export const getListData = (state: CampaignState) => state.listData.data
export const getListStatus = (state: CampaignState) => state.listData.status
export const getListPagination = (state: CampaignState) => state.listData.pagination
